import { ComponentClass } from 'react';
import { SubjectPickerProps, ISubjectPicker } from './components/SubjectPicker/SubjectPicker';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import { createLazyComponent, LazyModule, LazyModuleType, LazyImport } from 'owa-bundling';
import { isSubjectPickerSupported } from 'owa-mail-subject-picker-connector/lib/utils/isSubjectPickerSupported';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SubjectPicker" */ './lazyIndex')
);

export const SubjectPicker = createLazyComponent<
    SubjectPickerProps,
    LazyModuleType<typeof lazyModule>,
    ISubjectPicker
>(lazyModule, m => m.SubjectPicker);
export let lazyBackButtonPressed = new LazyImport(lazyModule, m => m.backButtonPressed);
export let lazyBackButtonHovered = new LazyImport(lazyModule, m => m.backButtonHovered);
export { doesSubjectPickerSupportPersona } from './utils/doesSubjectPickerSupportPersona';

export async function loadSubjectPickerModule(): Promise<void> {
    if (isSubjectPickerSupported()) {
        await lazyModule.import();
    }
}

export { ComponentClass, SubjectPickerProps, ISubjectPicker, FindRecipientPersonaType };
